import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { SortableExtractor } from '@common/UI/sortable/sortable.component';
import { Filterable } from '@common/utilities/Filterable';
import { DateRange, GoodReport, InvoiceRecord } from '@core/services/data.service';
import { PartnersService } from '@core/services/partners.service';
import { Multilingual } from '@core/utilities/multilingual';

@Component({
  templateUrl: './remaining-viewer.component.html',
  styleUrls: ['./remaining-viewer.component.scss']
})
export class RemainingViewerComponent implements OnInit {

  @Input()
  public range: { name: string, range: DateRange };

  @Input()
  public reports: GoodReport[];

  @Input()
  public SKU: string;

  @Input()
  public color: string;

  @Output()
  public changed = new EventEmitter<InvoiceRecord>();


  public unconfirmed(invoice: InvoiceRecord) {
    this.modal.of(this).hide();
    this.changed.emit(invoice);
  }


  public details: Filterable<GoodReport> = new Filterable<GoodReport>({
    extractor: i => [i.Path[0], this.partner(i)],
    grouper: i => [{ name: 'Nguồn nhập', option: this.partner(i).toUpperCase() }]
  });

  constructor(private partners: PartnersService, private modal: ModalService) { }

  ngOnInit(): void {

    let lu: { [key: string]: GoodReport } = {};

    this.reports.forEach(i => {
      if (!lu[i.Path[0]]) {
        lu[i.Path[0]] = { ...i };

        let x = lu[i.Path[0]];

        x.Initial.LengthCount += x.Imports.LengthCount + x.Returns.LengthCount - x.Exports.LengthCount - x.ProviderLosses.LengthCount - x.CompanyLosses.LengthCount;
        x.Initial.LengthQuantity += x.Imports.LengthQuantity + x.Returns.LengthQuantity - x.Exports.LengthQuantity - x.ProviderLosses.LengthQuantity - x.CompanyLosses.LengthQuantity;
        x.Initial.LengthQuoteQuantity += x.Imports.LengthQuoteQuantity + x.Returns.LengthQuoteQuantity - x.Exports.LengthQuoteQuantity - x.ProviderLosses.LengthQuoteQuantity - x.CompanyLosses.LengthQuoteQuantity;
        x.Initial.WeightCount += x.Imports.WeightCount + x.Returns.WeightCount - x.Exports.WeightCount - x.ProviderLosses.WeightCount - x.CompanyLosses.WeightCount;
        x.Initial.WeightQuantity += x.Imports.WeightQuantity + x.Returns.WeightQuantity - x.Exports.WeightQuantity - x.ProviderLosses.WeightQuantity - x.CompanyLosses.WeightQuantity;
        x.Initial.WeightQuoteQuantity += x.Imports.WeightQuoteQuantity + x.Returns.WeightQuoteQuantity - x.Exports.WeightQuoteQuantity - x.ProviderLosses.WeightQuoteQuantity - x.CompanyLosses.WeightQuoteQuantity;
        x.Initial.BaseWorth += x.Imports.BaseWorth + x.Returns.BaseWorth - x.Exports.BaseWorth - x.ProviderLosses.BaseWorth - x.CompanyLosses.BaseWorth;

      }
      else {

        let x = lu[i.Path[0]];

        x.Initial.LengthCount += i.Initial.LengthCount + i.Imports.LengthCount + i.Returns.LengthCount - i.Exports.LengthCount - i.ProviderLosses.LengthCount - i.CompanyLosses.LengthCount;
        x.Initial.LengthQuantity += i.Initial.LengthQuantity + i.Imports.LengthQuantity + i.Returns.LengthQuantity - i.Exports.LengthQuantity - i.ProviderLosses.LengthQuantity - i.CompanyLosses.LengthQuantity;
        x.Initial.LengthQuoteQuantity += i.Initial.LengthQuoteQuantity + i.Imports.LengthQuoteQuantity + i.Returns.LengthQuoteQuantity - i.Exports.LengthQuoteQuantity - i.ProviderLosses.LengthQuoteQuantity - i.CompanyLosses.LengthQuoteQuantity;
        x.Initial.WeightCount += i.Initial.WeightCount + i.Imports.WeightCount + i.Returns.WeightCount - i.Exports.WeightCount - i.ProviderLosses.WeightCount - i.CompanyLosses.WeightCount;
        x.Initial.WeightQuantity += i.Initial.WeightQuantity + i.Imports.WeightQuantity + i.Returns.WeightQuantity - i.Exports.WeightQuantity - i.ProviderLosses.WeightQuantity - i.CompanyLosses.WeightQuantity;
        x.Initial.WeightQuoteQuantity += i.Initial.WeightQuoteQuantity + i.Imports.WeightQuoteQuantity + i.Returns.WeightQuoteQuantity - i.Exports.WeightQuoteQuantity - i.ProviderLosses.WeightQuoteQuantity - i.CompanyLosses.WeightQuoteQuantity;
        x.Initial.BaseWorth += i.Initial.BaseWorth + i.Imports.BaseWorth + i.Returns.BaseWorth - i.Exports.BaseWorth - i.ProviderLosses.BaseWorth - i.CompanyLosses.BaseWorth;
      }
    })

    let source: GoodReport[] = [];

    for (let o in lu) source.push(lu[o]);   

    this.details.source = source.filter(i => i.Initial.LengthCount + i.Initial.WeightCount > 0);
  }

  public partner(report: GoodReport): string {

    if (this.partners.all.length < 1) return '#';

    let partner = this.partners.get(parseInt(report.Path[0].substr(1).split('.')[0]));
    return partner ? partner.Name : Multilingual.getText('Xưởng');
  }

  public extractor(field: string): SortableExtractor<GoodReport> {
    return {
      extract: i => {
        switch (field) {
          case 'Tag': return i.Path[0];
          case 'ReducedQuantity': return i.Initial.LengthQuantity - i.Initial.LengthQuoteQuantity + i.Initial.WeightQuantity - i.Initial.WeightQuoteQuantity;
          case 'QuoteQuantity': return i.Initial.LengthQuoteQuantity + i.Initial.WeightQuoteQuantity;
          case 'Price': return i.Initial.BaseWorth / (i.Initial.LengthQuoteQuantity + i.Initial.WeightQuoteQuantity);
          case 'Subtotal': return i.Initial.BaseWorth;
          default: return i.Initial[field];
        }
      }
    }
  }

  public sum(field: string): number {
    return this.details.matches.sum(i => {
      switch (field) {
        case 'ReducedLength': return i.Initial.LengthQuantity - i.Initial.LengthQuoteQuantity;
        case 'ReducedWeight': return i.Initial.WeightQuantity - i.Initial.WeightQuoteQuantity;
        case 'Subtotal': return i.Initial.BaseWorth;
        default: return i.Initial[field];
      }
    });
  }
}
